import classNames from 'classnames';
import Script from 'next/script';
import { FC } from 'react';

import { isValidUrl } from '../helpers/links';

interface Props {
  className?: string;
  url: string;
}

export const InstagramWidget: FC<Props> = ({ className, url }) => {
  if (!isValidUrl(url)) {
    return null;
  }

  return (
    <>
      <blockquote className={classNames('instagram-media', className)}>
        <a href={url}> </a>
      </blockquote>
      <Script
        async
        src="https://www.instagram.com/embed.js"
        strategy="afterInteractive"
      />
    </>
  );
};
